const PRODUCT_HANDLE = 'vipcoo-h2-electric-dirt-bike';
const PRODUCT_URL = 'https://vipcoo.eu/products/vipcoo-h2-electric-dirt-bike?variant=48510938382585';
const FALLBACK_VARIANT_ID = 48510938382585;
let firstVariant = { id: FALLBACK_VARIANT_ID, price: 109900, compare_at_price: 179900 };

const track = (name, detail = {}) => {
  const eventName = `vp_lp_${name}`;
  if (typeof window.gtag === 'function') window.gtag('event', eventName, detail);
  else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: eventName, ...detail });
  if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, detail);
};

const formatMoney = cents => new Intl.NumberFormat('fr-FR', {
  style: 'currency', currency: 'EUR', maximumFractionDigits: 0
}).format(cents / 100).replace(/\u202f/g, ' ');

const renderPrice = variant => {
  document.querySelectorAll('[data-live-price]').forEach(el => el.textContent = formatMoney(variant.price));
  document.querySelectorAll('[data-compare-price]').forEach(el => {
    const visible = variant.compare_at_price && variant.compare_at_price > variant.price;
    el.hidden = !visible;
    if (visible) el.textContent = formatMoney(variant.compare_at_price);
  });
};

const productEndpoint = `${location.hostname.endsWith('vipcoo.eu') ? (window.Shopify?.routes?.root || '/') : 'https://vipcoo.eu/'}products/${PRODUCT_HANDLE}.js`;
fetch(productEndpoint, { headers: { Accept: 'application/json' } })
  .then(response => response.ok ? response.json() : Promise.reject(new Error(`HTTP ${response.status}`)))
  .then(product => {
    if (!product.variants?.length) throw new Error('No variants');
    firstVariant = product.variants[0];
    renderPrice(firstVariant);
    track('price_loaded', { variant_id: String(firstVariant.id), value: firstVariant.price / 100, currency: 'EUR' });
  })
  .catch(() => renderPrice(firstVariant));

document.querySelectorAll('[data-buy-now]').forEach(link => link.addEventListener('click', () => {
  track('product_page_click', { variant_id: String(firstVariant.id), value: firstVariant.price / 100, currency: 'EUR' });
}));

document.querySelectorAll('[data-next]').forEach(button => button.addEventListener('click', () => {
  const trackElement = document.getElementById(button.dataset.next);
  trackElement.scrollBy({ left: trackElement.clientWidth * .78, behavior: 'smooth' });
}));
document.querySelectorAll('[data-prev]').forEach(button => button.addEventListener('click', () => {
  const trackElement = document.getElementById(button.dataset.prev);
  trackElement.scrollBy({ left: -trackElement.clientWidth * .78, behavior: 'smooth' });
}));

const modal = document.getElementById('video-player');
const iframe = modal.querySelector('iframe');
const parseYouTubeVideo = value => {
  const raw = (value || '').trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(raw)) return { id: raw, start: 0 };
  try {
    const url = new URL(raw);
    let id = '';
    if (url.hostname === 'youtu.be') id = url.pathname.split('/').filter(Boolean)[0] || '';
    else if (url.hostname.includes('youtube.com')) {
      id = url.searchParams.get('v') || url.pathname.match(/\/(?:embed|shorts|live)\/([A-Za-z0-9_-]{11})/)?.[1] || '';
    }
    const time = url.searchParams.get('t') || url.searchParams.get('start') || '0';
    const start = /^\d+$/.test(time) ? Number(time) : ((Number(time.match(/(\d+)m/)?.[1]) || 0) * 60 + (Number(time.match(/(\d+)s/)?.[1]) || 0));
    return /^[A-Za-z0-9_-]{11}$/.test(id) ? { id, start } : null;
  } catch { return null; }
};
const closeVideo = () => {
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  iframe.src = '';
  document.body.style.overflow = '';
};
document.querySelectorAll('[data-video-id]').forEach(card => card.addEventListener('click', event => {
  event.preventDefault();
  const video = parseYouTubeVideo(card.dataset.videoId);
  if (!video) return;
  const startAt = Number(card.dataset.videoStart || video.start || 0);
  const pageOrigin = location.protocol === 'http:' || location.protocol === 'https:' ? location.origin : 'https://vipcoo.eu';
  const pageReferrer = location.protocol === 'http:' || location.protocol === 'https:' ? location.href : 'https://vipcoo.eu/';
  const params = new URLSearchParams({ autoplay: '1', playsinline: '1', rel: '0', enablejsapi: '1', origin: pageOrigin, widget_referrer: pageReferrer });
  if (startAt > 0) params.set('start', String(startAt));
  iframe.src = `https://www.youtube.com/embed/${video.id}?${params.toString()}`;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  track('video_play', { video_id: video.id, video_title: card.querySelector('b')?.textContent || '' });
}));
modal.querySelector('.video-close').addEventListener('click', closeVideo);
modal.addEventListener('click', event => { if (event.target === modal) closeVideo(); });
document.addEventListener('keydown', event => { if (event.key === 'Escape') closeVideo(); });
